import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Wrapper, InnerWrapper, Form, SearchWrapper, SearchField, ActionWrapper, ActionButton } from './SearchInput.style';

var SearchInput = function SearchInput(_ref) {
  var onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["onChange", "placeholder", "value"]);

  return React.createElement(Wrapper, null, React.createElement(InnerWrapper, null, React.createElement(Form, {
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    }
  }, React.createElement(SearchWrapper, null, React.createElement(SearchField, Object.assign({
    value: value,
    onChange: onChange,
    name: "search",
    showLabel: false,
    type: "text",
    label: "Search",
    id: "search",
    placeholder: placeholder,
    errorMsg: ""
  }, rest))), React.createElement(ActionWrapper, null, React.createElement(ActionButton, {
    showLabel: false,
    disabled: "disabled",
    type: "submit",
    id: "",
    name: "action",
    placeholder: "",
    label: "",
    errorMsg: ""
  })))));
};

SearchInput.defaultProps = {
  placeholder: ''
};
export default SearchInput;